import { render, staticRenderFns } from "./UserFollow.vue?vue&type=template&id=23c53fcf&scoped=true&"
import script from "./UserFollow.vue?vue&type=script&lang=js&"
export * from "./UserFollow.vue?vue&type=script&lang=js&"
import style0 from "./UserFollow.vue?vue&type=style&index=0&id=23c53fcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c53fcf",
  null
  
)

export default component.exports